import { type Timestampable } from "./Timestampable.js";

export type Card = {
    id: ID;
    name: ID;
    description: string;
    body: Content[];
    helpUrl?: string;
    videoUrl?: string;
} & Partial<Timestampable>;

export type Content = {
    type: ContentType;
    value: string;
    // Dimensions: fixed width, height flow
} & Partial<Timestampable>;

export enum ContentType {
    EMBED = "embed",
    TEXT = "text",
    IMAGE = "image",
}
